<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="app-containe">
    <!-- 左侧导航栏 -->
    <el-menu
      class="side-menu"
      :default-active="activeMenu"
      :open="openMenus"
      background-color="#E9F6FF"
      text-color="#000"
      active-text-color="#409EFF"
      @select="handleMenuSelect"
      :collapse="isCollapsed"
      unique-opened
    >
      <el-submenu
        v-for="(course, index) in courses"
        :key="course.id"
        :index="course.id.toString()"
      >
        <template #title>{{ course.courseName }}</template>
        <!-- 二级菜单 -->
        <el-menu-item :index="'video-' + course.id">
          <img :src="activeMenu === ('video-' + course.id) ? '/image/video-icon-active.png' : '/image/video-icon.png'" class="menu-item-icon" />
          教程视频
        </el-menu-item>
        <el-menu-item :index="'pdf-' + course.id">
          <img :src="activeMenu === ('pdf-' + course.id) ? '/image/video-icon-active.png' : '/image/video-icon.png'" class="menu-item-icon" />
          PDF 文件
        </el-menu-item>
      </el-submenu>
    </el-menu>

    <!-- 右侧内容区域 -->
    <div class="content">
      <div v-if="activeContent.type === 'video'">
        <h4>{{ activeContent.courseName }} - 教程视频</h4>
        <video controls style="width: 90%; height: 500px; margin-top: 50px;" :src="activeContent.url" />
      </div>
      <div v-else-if="activeContent.type === 'pdf'">
        <h4>{{ activeContent.courseName }} - PDF 文件</h4>
        <iframe :src="activeContent.url" frameborder="0" width="750px" height="500px"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Dashboard',
  data() {
    return {
      courses: [], // 存储课程数据
      activeContent: {
        type: '', // 'video' 或 'pdf'
        courseName: '',
        url: '',
      },
      isCollapsed: false,
      openMenus: [], // 用于存储展开的一级菜单项 ID
      activeMenu: '', // 当前选中的菜单项
    };
  },
  methods: {
    async fetchCourses() {
      try {
        const response = await axios.get('/api/courseTeaching/all');
        if (response.data.code === 0 && response.data.success) {
          this.courses = response.data.data;
          console.log(this.courses);
          
          this.selectDefaultCourse(); // 加载第一个课程的视频
        } else {
          console.error('获取课程数据失败:', response.data.msg);
        }
      } catch (error) {
        console.error('请求课程数据时出错:', error);
      }
    },

    handleMenuSelect(key) {
  const [type, id] = key.split('-');
  const selectedCourse = this.courses.find(course => course.id.toString() === id);

  if (selectedCourse) {
    this.activeContent.type = type;
    this.activeContent.courseName = selectedCourse.courseName;
    this.activeContent.url = 
      type === 'video' 
        ? `/resources/static/${selectedCourse.videosUrl}` 
        : `/resources/static/${selectedCourse.fileUrl}`;
    this.activeMenu = key; // 设置当前选中的菜单项
  }
}
,

    selectDefaultCourse() {
      const firstCourse = this.courses[0];
      if (firstCourse) {
        const defaultKey = `video-${firstCourse.id}`;
        this.openMenus.push(firstCourse.id.toString()); // 展开第一个课程的一级菜单
        this.handleMenuSelect(defaultKey); // 默认选中第一个课程的视频
      }
    },
  },
  mounted() {
    this.fetchCourses(); // 组件加载时获取课程数据
  },
};
</script>

<style scoped>
.app-containe {
  display: flex;
  height: 100%;
  overflow: hidden;
  background: #fff;
  padding: 30px;
  border-radius: 20px;
}

.side-menu {
  width: 200px;
  height: 88vh;
  margin-right: 30px;
  padding-top: 20px;
  overflow-y: auto;
  border-radius: 10px;
  border: none;
}

.content {
  flex: 1;
  padding: 20px;
  background-color: #e9f6ff;
  border-radius: 20px;
}

.content h4 {
  margin-top: 0px;
}

video {
  width: 100%;
  height: auto;
}

/* 课程菜单项背景色与无阴影 */
::v-deep(.el-submenu) {
  background: #E9F6FF !important;
  box-shadow: none !important;
}
::v-deep(.el-submenu__title) {
  background: #E9F6FF !important;
  box-shadow: none !important;
}
::v-deep(.el-menu--inline) {
  background: #E9F6FF !important;
  box-shadow: none !important;
}

::v-deep(.el-submenu__title) {
  border-radius: 8px;
  padding: 10px 20px;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep(.el-menu-item) {
  background-color: #f0f8ff;
  border-radius: 4px;
  font-size: 14px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep(.el-menu-item:hover) {
  background-color: #e0e0e0;
}

::v-deep(.el-submenu.is-active .el-submenu__title) {
  background-color: #dcecff;
  color: #333;
}

::v-deep(.el-menu-item.is-active) {
  background-color: #dcecff;
  color: #333;
}

.menu-item-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
